const e = "_menuItemContainer_xdo0o_1", n = {
  menuItemContainer: e
};
export {
  n as default,
  e as menuItemContainer
};
//# sourceMappingURL=MenuItemContainer.module.css.js.map
